import { AnalyticsQueueEvent, analyticsQueueStore } from '~/modules/analytics/analyticsQueueStore';
import { RECOMMENDATION_SERVICE_URL } from '~/modules/config';
import { throwDevelopmentOrLog } from '~/modules/utilities/cross_env_utils';
import { AnalyticsTarget } from './analyticsTarget';
import { CoveoEventType } from './coveoEventTypes/coveoEventType';
import { CoveoEventTypeFactory } from './coveoEventTypes/coveoEventTypeFactory';

export class CoveoAnalyticsTarget implements AnalyticsTarget {
    private endpoint: string = RECOMMENDATION_SERVICE_URL + '/v2';

    // @ts-expect-error * Automated Type Error Fix
    postEvent(event): Promise<unknown> {
        const eventType: CoveoEventType = CoveoEventTypeFactory.getEventType(event);
        if (eventType) {
            const analyticsQueueEvent: AnalyticsQueueEvent = { target: this, event: event, eventType };
            analyticsQueueStore.sendAnalyticsEvent(analyticsQueueEvent);
        }
        return Promise.resolve();
    }

    sendAnalyticsEvent(analyticsEvent: AnalyticsQueueEvent): void {
        const eventType = analyticsEvent.eventType;
        if (eventType && eventType instanceof CoveoEventType) {
            const postUrl = this.buildUrl((eventType as CoveoEventType).getPath());

            if (postUrl) {
                const postRequest = new Blob([JSON.stringify(eventType.getBody(analyticsEvent.event))], {
                    type: 'text/plain',
                });
                navigator.sendBeacon(postUrl, postRequest);
            }
        }
    }

    buildUrl(path: string) {
        if (!path) {
            throwDevelopmentOrLog(new Error(`Missing event parameters. Path: ${path}`));
            return undefined;
        }
        return `${this.endpoint}/analytics-events?path=${path}`;
    }
}
